import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { QuestionConceptListItem } from '../models/question-concept-list-item';

@Injectable({
  providedIn: 'root'
})
export class QuestionConceptService extends HttpBaseService{

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.QuestionConcept, notifyServ, localizationService, configService);
  }

  getListByFilter(filter: any): Observable<QuestionConceptListItem[]> {
    return this.post("GetListByFilter", filter, true);
  }
}
